/**
 * Florida Pick 2–5 draw/sync schedule (official times in Eastern Time).
 * Play windows in the app are Cuba civil time — use `windowsForLotterySource('florida')`.
 * @see docs/lottery.md
 *
 * Results are fetched at draw + {@link FLORIDA_RESULTS_SYNC_OFFSET_MINUTES}
 * (feeds typically post within minutes; the app’s cron uses this fixed offset).
 *
 * House **results-wait blocks** (no plays) are derived from the official draw
 * clock with {@link RESULTS_WAIT_BLOCK_OFFSETS}, then projected ET→Cuba.
 */
/** Minutes after an official draw when Alea runs auto-sync. */
export const FLORIDA_RESULTS_SYNC_OFFSET_MINUTES = 10;

/**
 * Offsets from official Eastern draw times that define the results-wait block.
 * Winter EST reference (ET ≡ Cuba): midday 13:35–14:10, evening 21:40–22:20.
 */
export const RESULTS_WAIT_BLOCK_OFFSETS = {
  /** Midday (day) block start = middayDraw + this. */
  dayStartFromDrawMin: 5,
  /** Midday (day) block end = middayDraw + this. */
  dayEndFromDrawMin: 40,
  /** Evening (night) block start = eveningDraw + this (negative = before draw). */
  nightStartFromDrawMin: -5,
  /** Evening (night) block end = eveningDraw + this. */
  nightEndFromDrawMin: 35,
} as const;

/** Minutes after a results-wait block ends before the next turn accepts plays. */
export const RESULTS_WAIT_REOPEN_MINUTES = 1;

export const FLORIDA_LOTTERY_SCHEDULE = {
  middayDraw: '13:30',
  middaySync: '13:40',
  eveningDraw: '21:45',
  eveningSync: '21:55',
  /** Cron timezone — must match official Eastern draw clock (DST-aware). */
  timezone: 'America/New_York',
} as const;

export const FLORIDA_PICK_GAMES = ['pick2', 'pick3', 'pick4', 'pick5'] as const;

export type FloridaDrawSession = 'midday' | 'evening';

export function floridaDrawWindow(session: FloridaDrawSession): 'day' | 'night' {
  return session === 'midday' ? 'day' : 'night';
}

export function floridaSyncCron(session: FloridaDrawSession): string {
  const [h, m] = (session === 'midday'
    ? FLORIDA_LOTTERY_SCHEDULE.middaySync
    : FLORIDA_LOTTERY_SCHEDULE.eveningSync
  ).split(':').map(Number);
  return `${m} ${h} * * *`;
}
